// utils/exportUtils.js
import jsPDF from "jspdf";
import "jspdf-autotable";
import { exportFileStyles } from "../styles/exportfileStyles";

export const exportAsPDF = (theme, fileName, tableHeaders, tableRows, logoBase64) => {
  const doc = new jsPDF();
  const styles = exportFileStyles(theme);

  doc.setFont(styles.font);
  doc.setTextColor(styles.primaryColor);
  doc.setFontSize(styles.fontSize);

  doc.text(fileName, 20, 10);

  // Table Styling
  doc.autoTable({
    head: [tableHeaders],
    body: tableRows,
    startY: styles.marginTop,
    theme: "grid",
    styles: {
      font: styles.font,
      textColor: styles.primaryColor,
    },
    headStyles: {
      fillColor: styles.headerColor,
      textColor: styles.headerTextColor,
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: styles.rowStripeColor,
    },
    margin: { top: styles.marginTop },
  });

  // Ensure logo is valid before adding
  if (logoBase64 && typeof logoBase64 === "string" && logoBase64.startsWith("data:image")) {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    const logoWidth = 40; // Adjust width as needed
    const logoHeight = 15; // Adjust height as needed
    const logoX = (pageWidth - logoWidth) / 2; // Center horizontally
    const logoY = pageHeight - 20; // 20 units from the bottom

    doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
  } else {
    console.warn("Invalid or missing logoBase64:", logoBase64);
  }

  // Save the PDF
  doc.save(`${fileName}.pdf`);
};

export const exportAsCSV = (fileName, tableHeaders, tableRows) => {
  let csvContent = "\uFEFF" + tableHeaders.join(",") + "\r\n";
  tableRows.forEach((row) => {
    const formattedRow = row.map((value) => `"${value}"`).join(",");
    csvContent += formattedRow + "\r\n";
  });
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
